import { guid } from "@buildwithflux/shared";
import { keys } from "lodash";
import { handleSetNodeRules } from "../document-actions";
/**
 * Applies PCB layout node rules actions by updating or removing rules for PCB nodes
 * @param action The PCB layout node rules action to apply
 * @param dependencies The dependencies needed to apply the action
 * @returns A promise that resolves to the result of applying the action
 */
export function applyPcbLayoutNodeRulesAction(action, document) {
    const touchedElementUids = [];
    const updatedNodesRulesSetsMap = {};
    // eslint-disable-next-line @buildwithflux/no-array-foreach
    action.forEach((nodeRuleUpdate) => {
        const { nodeUid, rulesToAddOrEdit, rulesToRemove } = nodeRuleUpdate;
        const currentNode = document.pcbLayoutNodes?.[nodeUid];
        const currentRules = currentNode?.pcbNodeRuleSet || {};
        const updatedRules = { ...currentRules };
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        rulesToRemove.forEach((ruleKey) => {
            delete updatedRules[ruleKey];
        });
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        rulesToAddOrEdit.forEach(({ key, value, order, disabled }) => {
            const existingRule = updatedRules[key];
            if (existingRule) {
                updatedRules[key] = {
                    ...existingRule,
                    value,
                    ...(order !== undefined && { order }),
                    ...(disabled !== undefined && { disabled }),
                };
            }
            else {
                const newRule = {
                    uid: guid(),
                    key,
                    value,
                    order: order !== undefined ? order : Object.keys(updatedRules).length,
                    disabled: disabled !== undefined ? disabled : false,
                };
                updatedRules[key] = newRule;
            }
        });
        if (rulesToAddOrEdit.length > 0 || rulesToRemove.length > 0) {
            updatedNodesRulesSetsMap[nodeUid] = {
                nodeUid,
                updatedPcbLayoutRules: updatedRules,
            };
            touchedElementUids.push(nodeUid);
        }
    });
    if (keys(updatedNodesRulesSetsMap).length > 0) {
        handleSetNodeRules(document, updatedNodesRulesSetsMap);
    }
    return {
        pcbLayoutRulesUpdated: action.map((update) => ({
            nodeUid: update.nodeUid,
            rulesUpdated: [...update.rulesToAddOrEdit],
            rulesRemoved: [...update.rulesToRemove],
        })),
        touchedElementUids,
    };
}
//# sourceMappingURL=applyPcbLayoutNodeRulesAction.js.map